import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "how container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "how__title title" }, "Как это работает", -1)
const _hoisted_3 = { class: "how__list" }
const _hoisted_4 = ["index"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.howData, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          index: index,
          key: index,
          class: "how__item"
        }, [
          _createElementVNode("img", {
            src: _ctx.IMAGE_BASE_URL + item.imgUrl,
            alt: "Иллюстрация"
          }, null, 8, _hoisted_5),
          _createElementVNode("p", {
            class: "how__desc",
            id: `desc-${item.id}`
          }, null, 8, _hoisted_6)
        ], 8, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("img", {
      src: _ctx.IMAGE_BASE_URL + 'lines.png',
      alt: "",
      class: "how__lines"
    }, null, 8, _hoisted_7)
  ]))
}